import { motion } from 'framer-motion';

import Portal from '../../commonComponents/Portal';
import { ConfirmPopupContent } from './ConfirmPopupContent';

export default function ConfirmPopup({
  rightButtonAction,
  leftButtonAction,
  rightButtonText,
  leftButtonText,
  title,
  titleStyle,
  description,
  descriptionStyle,
  Icon,
  closePopup,
  showClosePopupIcon,
  modalStyle,
  modalContainerStyle = {},
  children,
  leftButtonStyle,
  rightButtonStyle,
  rightButtonDisabled,
  leftButtonDisabled,
  rightButtonLoading,
  dataCy,
  dataTestId,
  closePopupDataCy,
  leftButtonDataCy,
  rightButtonDataCy,
  dismissiblePopup = true,
}) {
  return (
    <Portal>
      <div
        className="modal"
        data-testid={dataTestId}
        data-cy={closePopupDataCy || 'modal-backdrop'}
        onClick={dismissiblePopup ? closePopup : () => {}}
        onMouseDown={(e) => e.stopPropagation()}
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999, ...modalContainerStyle }}
      >
        <motion.div
          animate={{ opacity: 1, y: 0 }}
          className="modal_content"
          data-cy={dataCy || 'modal'}
          exit={{ opacity: 0 }}
          initial={{ opacity: 0, y: -10 }}
          style={{ position: 'relative', padding: '45px 10px', ...modalStyle }}
          transition={{ duration: 0.5 }}
          onClick={(event) => event.stopPropagation()}
        >
          <ConfirmPopupContent
            rightButtonAction={rightButtonAction}
            rightButtonDataCy={rightButtonDataCy}
            leftButtonAction={leftButtonAction}
            leftButtonDataCy={leftButtonDataCy}
            rightButtonText={rightButtonText}
            leftButtonText={leftButtonText}
            title={title}
            titleStyle={titleStyle}
            description={description}
            descriptionStyle={descriptionStyle}
            Icon={Icon}
            closePopup={closePopup}
            closePopupDataCy={closePopupDataCy || 'modal-close'}
            showClosePopupIcon={showClosePopupIcon}
            leftButtonStyle={leftButtonStyle}
            rightButtonStyle={rightButtonStyle}
            rightButtonDisabled={rightButtonDisabled}
            leftButtonDisabled={leftButtonDisabled}
            rightButtonLoading={rightButtonLoading}
          >
            {children}
          </ConfirmPopupContent>
        </motion.div>
      </div>
    </Portal>
  );
}
